import { TmHttpClient } from '@treasury/core/http';

export async function getLoanPaymentDetails(id: string) {
    return (await TmHttpClient.getInstance()).request(`internalTransfers/?id=${id}`, {
        method: 'GET',
    });
}
